import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=618a8c7a&"
import script from "./DonutChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./DonutChart.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports